import { AccountObject } from "./account-object.model";
import { VasBaseObjectApiFacade } from "../base-object/vas-base-object.api-facade";
import { Observable } from "rxjs/Observable";

export abstract class AccountObjectApiFacade<T extends AccountObject> extends VasBaseObjectApiFacade<T> {

    abstract get(accountId: string, id: string, ...args): Observable<T>;

    abstract getAll(accountId: string, ...args): Observable<Array<T>>;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-object/account-object.api-facade.ts